import axios from 'axios'
import { Message, MessageBox } from 'element-ui'
import store from '../store'
import { getToken } from '@/utils/auth'
import Cookies from 'js-cookie'

// 创建axios实例
const service = axios.create({
  baseURL: process.env.BASE_API, // api的base_url
  // baseURL:"http://192.168.3.148:8000/",
  timeout: 30000, // 请求超时时间
  withCredentials:true,
})

// request拦截器
service.interceptors.request.use(config => {
  let merchantId = store.getters.merchantId;
  // config.headers["Access-Control-Allow-Origin"]="*"
  if (store.getters.token) {
    // config.headers["JSESSIONID"]=""
    config.headers['Authorization'] = getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
  }
  if (merchantId && merchantId != '') {
    if (config.method == 'get') {
      let params = config.params;
      // let data = config.data;
      config.headers['merchantId'] = merchantId
      if(!params){
        params = {};
      }
      // data.merchantId = merchantId
      // params.merchantId = merchantId
    } else if (config.method == 'post') {
      if (config.headers['content-type'] == 'application/json') {
        let obj = JSON.parse(config.data);
        if(!obj){
          obj = {};
        }
        if(store.getters.name!='admin'){
          obj.merchantId = merchantId;
        }
        // else{
        //   obj.merchantId=''
        // }
        config.data = JSON.stringify(obj);
      } else {
        let data = config.data;
        if(!data){
          data = new FormData();
        }
        if(data instanceof FormData){
          if(store.getters.name!='admin'){
            data.append('merchantId', merchantId);
          }
          // else{
          //   data.append('merchantId','')
          // }
        }else{
          if(store.getters.name!='admin'){
            data.merchantId = merchantId;
          }
          // else{
          //   data.merchantId=''
          // }
        }
        
      }
    }
  }

  return config
}, error => {
  // Do something with request error
  console.log(error) // for debug
  Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(
  response => {
    /**
    * code为非200是抛错 可结合自己业务进行修改
    */
    const res = response.data
    let code = res.code || res.retCode;
    let msg = res.message || res.retMsg;
    if (code != 200 && code != "0000") {
      Message({
        message: msg,
        type: 'error',
        duration: 3 * 1000
      })

      // 401:未登录;
      if (code === 401) {
        MessageBox.confirm('你已被登出，可以取消继续留在该页面，或者重新登录', '确定登出', {
          confirmButtonText: '重新登录',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          store.dispatch('FedLogOut').then(() => {
            location.reload()// 为了重新实例化vue-router对象 避免bug
          })
        })
      }
      return Promise.reject('error')
    } else {
      return res;
    }
  },
  error => {
    console.log('err' + error)// for debug
    Message({
      message: error.message,
      type: 'error',
      duration: 3 * 1000
    })
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js